import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class GetLLMTestSuiteService extends BaseService {
  constructor() {
    super(constants.GET_TEST_SUITE_DATA, 'GetLLMTestSuiteServiceStatus');
  }

  handleEvent(eventName, event) {
    const headers = utils.buildHeadersWithTenantId(event);
    return this.getClient('aiadmin').get(`/effectiveness/tests`, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      //   const notification = {
      //     open: true,
      //     type: 'success',
      //     message: 'Data Added successfully'
      //   };
      // Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('llmEvaluationTestSuiteData').setResponse(response);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
